import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import NavigationRequests from "../../visComponents/navigation/navigationRequests";
import LoadingSpinner from "../../ui/loadingSpinner";
import SimilarProductsListItem from "./similarProductsListItem";
import {cartItemInterface} from "../cartItemInterface";
import {FormattedMessage} from "react-intl";

class SimilarProductsList extends NavigationRequests {

  static propTypes = {
    cartItem: PropTypes.shape(cartItemInterface),
    addedCountertops: PropTypes.arrayOf(PropTypes.shape(cartItemInterface)),
    subPart: PropTypes.object.isRequired,
    updateParent: PropTypes.func.isRequired,
    featuresCollectionsList: PropTypes.array.isRequired,
  };

  componentDidMount() {
    const {subPart, updateParent} = this.props;
    this.checkIfAllFeaturesReceived(subPart, "", () => {
      this.forceUpdate();
      updateParent(); // get new features
    });
  }

  render() {

    const {subPart, cartItem, featuresCollectionsList, quoteIndex, addedCountertops} = this.props;

    if (!subPart.part.allFeaturesReceived) {
      return <LoadingSpinner/>
    }

    const totalCountertopsQuantity = addedCountertops.reduce(((accumulator, cItem) => accumulator + cItem.quantity), 0);

    return (
      <div className="similar-content">
        <ul className="similar-list">
          <li className="similar-item similar-item--no-border">
            <div className="similar-block">
              <span className="similar-block__title"><FormattedMessage id="similar.filterName"/></span>
            </div>
            <div className="similar-block text-right">
              <span className="similar-block__title"><FormattedMessage id="similar.product.priceProject"/></span>
            </div>
          </li>
          {featuresCollectionsList.map(featureCollection => {
            return <SimilarProductsListItem key={featureCollection.id}
                                            cartItem={cartItem}
                                            addedCountertops={addedCountertops}
                                            totalCountertopsQuantity={totalCountertopsQuantity}
                                            quoteIndex={quoteIndex}
                                            featureCollection={featureCollection}/>
          })}
        </ul>
      </div>
    )
  }
}

const mapStateToProps = () => {
  return {};
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(SimilarProductsList);

